import React, { useState } from 'react'
import INFWalletCard from './INFWalletCard'
import { NFTCard } from '../NFTCard'
import NFTSellModal from '../NFTSellModal'
import { useActiveWeb3React } from '../../../../hooks'
import { getSaleToken } from '../../utils/NFTFormatedData'
import NFTTransferModal from '../NFTTransferModal'

export default function NFTWalletCard(props: INFWalletCard) {
  const {
    contractAddress,
    getSalesNFTItems,
   // account,
    tokenId,
    yetiswapMarketCommissionRateYTS,
    yetiswapMarketCommissionRateNonYTS,
    owner,
    priceInfo
  } = props
  const { chainId } = useActiveWeb3React()
  const saleToken = getSaleToken(undefined, chainId)
  const [saleModalIsOpen, setSaleModalIsOpen] = useState(false)
  const [transferModalIsOpen, setTransferModalIsOpen] = useState(false)
  const [nftName, setNFTName] = useState('')

  function showSetSaleModal(nftName: string) {
    setNFTName(nftName)
    setSaleModalIsOpen(true)
  }
  function showTransferModel(nftName: string) {
    setNFTName(nftName)
    setTransferModalIsOpen(true)
  }
  function cancelSaleModal() {
    setSaleModalIsOpen(false)
  }
  function cancelTransferModal() {
    setTransferModalIsOpen(false)
  }

  return (
    <React.Fragment>
      <NFTCard
        tokenId={tokenId}
        tokenContractAddress={contractAddress}
        setSale={showSetSaleModal}
        transferNFT={showTransferModel}
        isWallet={true}
        //account={account}
        saleToken={saleToken}
        owner={owner}
        priceInfo={priceInfo}
      />
      <NFTSellModal
        isOpen={saleModalIsOpen}
        onDismiss={() => cancelSaleModal()}
        NFTName={nftName}
        tokenId={tokenId}
        tokenContractAddress={contractAddress}
        getSalesNFTItems={getSalesNFTItems}
        yetiswapMarketCommissionRateYTS={yetiswapMarketCommissionRateYTS}
        yetiswapMarketCommissionRateNonYTS={yetiswapMarketCommissionRateNonYTS}
        //account={account}
        priceInfo={priceInfo}
      />
      <NFTTransferModal
        NFTName={nftName}
        isOpen={transferModalIsOpen}
        onDismiss={() => cancelTransferModal()}
        tokenId={tokenId}
        getSalesNFTItems={getSalesNFTItems}
        tokenContractAddress={contractAddress}
      />
    </React.Fragment>
  )
}
